import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { Typography, Box, Button } from "@mui/material";

import AllRoutes from "./Router/AllRoutes";
import DummyStepPage from "./Pages/DummyStepPage";
import Login from "./Pages/Login";
import axios from "axios";
import RegisterCandidate from "./Pages/RegisterCandidate";
import StepWithFloatPage from "./Pages/StepWithFloatPage";

const App = () => {
  const [showToolbar, setShowToolbar] = useState(true);

   

 

  return (
    <>
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
      >
        <AllRoutes showToolbar={showToolbar} />
        {/* <Login/> */}
        {/* <DummyStepPage/> */}
        {/* <RegisterCandidate/> */}
        {/* <StepWithFloatPage/> */}
      </Box>

      <Box
        display="flex"
        flexDirection="column"
        position="fixed"
        bottom="32px"
        right="32px"
        gap="16px"
        zIndex={1000}
      >
        <Button
          variant="contained"
          color="secondary"
          component={NavLink}
          to="/PageViewer"
          sx={{
            borderRadius: "50%",
            minWidth: 0,
            width: 56,
            height: 56,
            boxShadow: 3,
            transition: "background 0.2s",
          }}
          style={({ isActive }) =>
            isActive
              ? {
                  background:
                    "linear-gradient(135deg, #6a11cb 0%, #2575fc 100%)",
                  color: "white",
                }
              : {
                  backgroundColor: "rgba(96,19,80,1)",
                }
          }
        >
          <Typography
            variant="caption"
            sx={{ color: "white", fontWeight: 700 }}
          >
            PV
          </Typography>
        </Button>

        <Button
          variant="contained"
          color="primary"
          component={NavLink}
          to="/ComponentList"
          sx={{
            borderRadius: "50%",
            minWidth: 0,
            width: 56,
            height: 56,
            boxShadow: 3,
            transition: "background 0.2s",
          }}
          style={({ isActive }) =>
            isActive
              ? {
                  background:
                    "linear-gradient(135deg, #6a11cb 0%, #2575fc 100%)",
                  color: "white",
                }
              : {
                  backgroundColor: "rgba(96,19,80,1)",
                }
          }
        >
          <Typography
            variant="caption"
            sx={{ color: "white", fontWeight: 700 }}
          >
            CL
          </Typography>
        </Button>
        <Button
          onClick={() => setShowToolbar(!showToolbar)}
          sx={{
            borderRadius: "50%",
            minWidth: 0,
            width: 56,
            height: 56,
            boxShadow: 3,
            backgroundColor: "rgba(96,19,80,1)",
            transition: "background 0.2s",
            color: "white",
            zIndex: 1000,
            "&:hover": {
              backgroundColor: "rgba(96,19,80,0.8)",
            },
          }}
        >
          {showToolbar ? "◀" : "▶"}
        </Button>
      </Box>

      {/* <Tod/> */}

      {/* <Associate/> */}
    </>
  );
};

export default App;
